var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.accessible)?_c('span',{class:['table-btn',_vm.btnClassName(_vm.type)],on:{"click":_vm.btnClick}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }